import { CustomTabAPI } from '@business/api/custom_tab';
import { SubContractorCategoryFormAPI } from '@business/api/subcontractorCategoryForm';
import { CustomTabId, CustomTabResponse } from '@business/entities/custom-tab';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap, tap } from 'rxjs/operators';

export class CustomTabBloc extends BaseBloc {
  private readonly customTabRepo = new Repository<CustomTabResponse>({
    getItemId: item => item.id,
  });

  readonly tabs$ = this.customTabRepo.items$;

  readonly selectTab = this.customTabRepo.selectItem;

  onReset() {
    this.customTabRepo.reset();
  }

  fetchProfileTabs = () => {
    return CustomTabAPI.fetchProfileTabs().pipe(this.customTabRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_profile_tab_error') }));
  };

  createTab = (data: Partial<CustomTabResponse>) => {
    return CustomTabAPI.createTab(data).pipe(
      this.customTabRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('create_profile_tab'),
      }),
    );
  };

  updateTab = (id: CustomTabId, service: Partial<CustomTabResponse>) => {
    return CustomTabAPI.updateTab(id, service).pipe(
      this.customTabRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_profile_tab'),
      }),
    );
  };

  deleteTab = (tabId: CustomTabId) => {
    return showDeleteConfirmation('Delete', 'Do you really want to delete this service class?').pipe(
      switchMap(() => CustomTabAPI.deleteTab(tabId)),
      this.customTabRepo.ops.removeOne(() => tabId),
      handleMessage({
        type: requestMessage('delete_profile_tab'),
      }),
    );
  };

  fetchTabForm = () => {
    return SubContractorCategoryFormAPI.fetchTabForm().pipe(handleMessage({ error: requestMessage('fetch_form_error') }));
  };

  formValueSave = (id: string, data: Partial<{}>) => {
    return CustomTabAPI.formValueSave(id, data).pipe(
      handleMessage({
        type: requestMessage('create_form_value'),
      }),
    );
  };
}
